export default "__VITE_ASSET__Da4piWrd__"